var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileMenuGalleryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 42,
    viewBox: "0 0 49 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 23.3007V35.6014C2 37.8106 3.79087 39.6014 6.00001 39.6014H38.0229C40.232 39.6014 42.0229 37.8106 42.0229 35.6014V26.8789M2 23.3007V11C2 8.79086 3.79086 7 6 7H38.0229C40.232 7 42.0229 8.79086 42.0229 11V26.8789M2 23.3007L7.28042 19.6826C8.44365 18.8856 9.94061 18.7599 11.2205 19.3519L17.7774 22.3844C19.0122 22.9555 20.4526 22.8599 21.601 22.1305L27.1733 18.5913C28.6064 17.6811 30.4581 17.7747 31.7921 18.8249L42.0229 26.8789",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.74074V6C6 3.79086 7.79086 2 10 2H43C45.2091 2 47 3.79086 47 6V30C47 32.2091 45.2091 34 43 34H42",
    stroke: "white",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuGalleryIcon);
export default __webpack_public_path__ + "static/media/MobileMenuGalleryIcon.642442f22b0de93c41dbf8b402f19f9f.svg";
export { ForwardRef as ReactComponent };